import styled from 'styled-components'

import { ArticleText } from 'shared/types/ArticleText'
import createSanitizedHtmlObject from 'shared/lib/sanitizeHtml'
import { colors, media } from 'shared/lib'

type ArticleTextSectionProps = {
  section: ArticleText
}

export const ArticleTextSection = ({ section }: ArticleTextSectionProps) => {
  if (!section?.text) {
    return null
  }

  return (
    <Container>
      <Text
        dangerouslySetInnerHTML={createSanitizedHtmlObject(section?.text)}
        data-qa="ArticleTextSectionText"
      />
    </Container>
  )
}

const Container = styled.div`
  align-items: center;
  color: #000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 120px;
  margin-top: 120px;
  padding-left: 24px;
  padding-right: 24px;
  width: 100vw;

  ${media.medium`
    margin-bottom: 240px;
    margin-top: 240px;
  `}
`
const Text = styled.div`
  color: #000;
  font-family: 'Ivar Text'; /* stylelint-disable-line font-family-no-missing-generic-family-keyword */
  font-size: 16px;
  font-weight: 400;
  line-height: 130%;
  max-width: 704px;

  a {
    color: ${colors.FC2_RED};
  }
`
